const BASE_URL = '/lishui-gov'
import request from '@/common/api/request'

// 消息模板管理-类别字典列表
export const categoryDictList = params => request(BASE_URL + '/smsTemplate/categoryDictList', { params })
// 消息模板管理-消息模板分页列表
export const smsTemplatePage = params => request(BASE_URL + '/smsTemplate/page', { params })
// 消息模板管理-新增或编辑消息模板
export const addOrEdit = params => request.post(BASE_URL + '/smsTemplate/addOrEdit', params)
// 消息模板管理-删除消息模板
export const deleteSms = params => request(BASE_URL + '/smsTemplate/delete', { params })
// 消息模板管理-类别分页列表
export const categoryPage = params => request(BASE_URL + '/smsTemplate/categoryPage', { params })
// 消息模板管理-新增或编辑类别
export const addOrEditCategory = params => request.post(BASE_URL + '/smsTemplate/addOrEditCategory', params)
// 消息模板管理-删除类别
export const deleteCategory = params => request(BASE_URL + '/smsTemplate/deleteCategory', { params })
